// frontend_react/src/pages/admin/ReplenishmentOrdersPage.jsx

import logger from '../../utils/logger';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Badge,
  Table,
  PageContainer,
  PageTitle,
  ErrorText,
} from '../../ui';
import {
  getReplenishmentOrders,
} from "../../services/replenishmentApi";
import CertificationModal from '../../components/CertificationModal';
import { useAdminScope } from "../../context/AdminScopeContext";

const Actions = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export default function ReplenishmentOrdersPage() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(null);
  const { selectedCompanyUuid } = useAdminScope();

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getReplenishmentOrders({
        companyUuid: selectedCompanyUuid,
      });
      setData(res.replenishments ?? []);
      setError(null);
    } catch (err) {
      logger.error(err);
      setError(
        err.response?.data?.error ||
          'Erreur lors du chargement des réassorts.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedCompanyUuid]);

  const handleCertified = () => {
    setSelected(null);
    fetchData();
  };

  return (
    <PageContainer>
      <PageTitle>Demandes de réassort</PageTitle>
      {loading ? (
        <p>Chargement…</p>
      ) : error ? (
        <ErrorText>{error}</ErrorText>
      ) : (
        <Table>
          <thead>
            <tr>
              <th>#</th>
              <th>Fournisseur</th>
              <th>Total TTC</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((r) => (
              <tr key={r.uuid}>
                <td>{r.reference}</td>
                <td>{r.supplier_name}</td>
                <td>{r.total.toFixed(2)} €</td>
                <td>
                  {r.certified ? (
                    <Badge color="green">Certifié</Badge>
                  ) : (
                    <Badge color="orange">En attente</Badge>
                  )}
                </td>
                <td>
                  <Actions>
                    {!r.certified && (
                      <Button onClick={() => setSelected(r)}>Certifier</Button>
                    )}
                    <Button onClick={() => navigate(`/admin/replenishment/${r.uuid}`)}>
                      Détails
                    </Button>
                  </Actions>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      

      {selected && (
        <CertificationModal
          open
          onClose={() => setSelected(null)}
          target={{
            uuid: selected.uuid,
            supplier: selected.supplier_name,
            total: selected.total,
            certified: selected.certified,
          }}
          onCertified={handleCertified}
        />
      )}
    </PageContainer>
  );
}